import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import withTranslations from '../../translations';
import classNames from 'classnames';
import { rootUrl } from '../../constants/urls';

import { Link } from 'react-router-dom';

import {
  Button,
  Paper,
  Typography,
} from '../../components/base';

import { headerHeight } from '../../constants/styles';

const styles = theme => ({
  flexCenter: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  root: {
    height: `calc(100vh - ${headerHeight}px)`,
  },
  paper: {
    padding: `${theme.spacing(2)}px ${theme.spacing(3)}px ${theme.spacing(6)}px`,
    flexDirection: 'column',
    justifyContent: 'space-around',
    height: '80%',
    width: '90%',
    minHeight: 200,
    maxHeight: 350,
    textAlign: 'center',

    '&>div': {
      marginBottom: theme.spacing(3),
    },

    [theme.breakpoints.up('sm')]: {
      padding: `${theme.spacing(4)}px ${theme.spacing(12)}px ${theme.spacing(8)}px`,
      maxWidth: 600,
    },
  },
  button: {
    color: theme.palette.primary.main,
  },
  link: {
    color: 'inherit',
    textDecoration: 'none',

    '&:active': {
      color: 'inherit'
    },
  },
})

const PageNotFoundView = ({ classes: c, gt }) =>
  <div className={classNames(c.root, c.flexCenter)}>
    <Paper className={classNames(c.paper, c.flexCenter)}>
      <Typography variant='h5'>{gt.Errors.pageNotFound}</Typography>
      <Typography variant='body1'>{gt.Errors.pageNotFoundParagraph1}</Typography>
      <Button
        className={c.button}
        onClick={this.handleClick}
        variant='contained'
        color='secondary'
      >
        <Link to={rootUrl()} className={c.link}>{gt.back}</Link>
      </Button>
    </Paper>
  </div>

export default withStyles(styles)(withTranslations(PageNotFoundView))



// WEBPACK FOOTER //
// ./src/views/PageNotFound/PageNotFoundView.js